import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Curso } from '../../interfaces/curso';

@Component({
  selector: 'app-cursos-carousel',
  templateUrl: './cursos-carousel.component.html',
  styleUrls: ['./cursos-carousel.component.css']
})
export class CursosCarouselComponent implements OnInit {

  @Input()
  cursos: Curso[];

  @Input()
  circular: boolean;

  @Input()
  itemsPerPage: number;

  @Input()
  autoplayInterval: number;

  public loading: boolean = true;

  public responsiveOptions;

  constructor(
    private router: Router
  ) { 
    this.responsiveOptions = [
      {
        breakpoint: '1900px',
        numVisible: 4,
        numScroll: 1
    },
      {
          breakpoint: '1600px',
          numVisible: 3,
          numScroll: 1
      },
      {
        breakpoint: '1200px',
        numVisible: 3,
        numScroll: 1
    },
    {
      breakpoint: '1024px',
      numVisible: 3,
      numScroll: 1
  },
      {
          breakpoint: '768px',
          numVisible: 2,
          numScroll: 1
      },
      {
          breakpoint: '560px',
          numVisible: 1,
          numScroll: 1
      }
  ];
  }


  goFormulario(curso_id: number, version: number) {
    this.router.navigate(['curso-detalle'], { queryParams: { curso_id: curso_id, version: version } })
  }


  ngOnInit(): void{

  }

  ngOnChanges(): void{
    if(this.cursos && this.cursos.length > 0){
      this.loading = false;
    }
  }

}
